import { render, staticRenderFns } from "./AddSkillModal.vue?vue&type=template&id=b0420240&scoped=true&"
import script from "./AddSkillModal.vue?vue&type=script&lang=js&"
export * from "./AddSkillModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSkillModal.vue?vue&type=style&index=0&id=b0420240&lang=scss&scoped=true&"
import style1 from "./AddSkillModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0420240",
  null
  
)

export default component.exports